/**
 * Kategori kartlarında kullanılan ince renk vurguları.
 * Sınıf isimleri tam string olarak yazılıyor (Tailwind JIT purge'e takılmaması için).
 */
export type CategoryColor =
  | "indigo"
  | "violet"
  | "sky"
  | "rose"
  | "teal"
  | "fuchsia"
  | "emerald"
  | "slate";

interface CategoryColorClasses {
  iconWrap: string;
  icon: string;
  hoverBorder: string;
}

export const categoryColorClasses: Record<CategoryColor, CategoryColorClasses> = {
  indigo: {
    iconWrap: "bg-indigo-500/10 dark:bg-indigo-500/15",
    icon: "text-indigo-600 dark:text-indigo-400",
    hoverBorder: "hover:border-indigo-400/70 dark:hover:border-indigo-500/50",
  },
  violet: {
    iconWrap: "bg-violet-500/10 dark:bg-violet-500/15",
    icon: "text-violet-600 dark:text-violet-400",
    hoverBorder: "hover:border-violet-400/70 dark:hover:border-violet-500/50",
  },
  sky: {
    iconWrap: "bg-sky-500/10 dark:bg-sky-500/15",
    icon: "text-sky-600 dark:text-sky-400",
    hoverBorder: "hover:border-sky-400/70 dark:hover:border-sky-500/50",
  },
  rose: {
    iconWrap: "bg-rose-500/10 dark:bg-rose-500/15",
    icon: "text-rose-600 dark:text-rose-400",
    hoverBorder: "hover:border-rose-400/70 dark:hover:border-rose-500/50",
  },
  teal: {
    iconWrap: "bg-teal-500/10 dark:bg-teal-500/15",
    icon: "text-teal-600 dark:text-teal-400",
    hoverBorder: "hover:border-teal-400/70 dark:hover:border-teal-500/50",
  },
  fuchsia: {
    iconWrap: "bg-fuchsia-500/10 dark:bg-fuchsia-500/15",
    icon: "text-fuchsia-600 dark:text-fuchsia-400",
    hoverBorder: "hover:border-fuchsia-400/70 dark:hover:border-fuchsia-500/50",
  },
  emerald: {
    iconWrap: "bg-emerald-500/10 dark:bg-emerald-500/15",
    icon: "text-emerald-600 dark:text-emerald-400",
    hoverBorder: "hover:border-emerald-400/70 dark:hover:border-emerald-500/50",
  },
  slate: {
    iconWrap: "bg-slate-500/10 dark:bg-slate-500/15",
    icon: "text-slate-600 dark:text-slate-400",
    hoverBorder: "hover:border-slate-400/70 dark:hover:border-slate-500/50",
  },
};
